// @ts-nocheck
import client from "../../utils/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { ResourceReservationValidateRecurrenceTimeConflictMutationRequest, ResourceReservationValidateRecurrenceTimeConflictMutationResponse, ResourceReservationValidateRecurrenceTimeConflict401 } from "../models/ResourceReservationValidateRecurrenceTimeConflict";
import type { UseMutationOptions } from "@tanstack/react-query";

 type ResourceReservationValidateRecurrenceTimeConflictClient = typeof client<ResourceReservationValidateRecurrenceTimeConflictMutationResponse, ResourceReservationValidateRecurrenceTimeConflict401, ResourceReservationValidateRecurrenceTimeConflictMutationRequest>;
type ResourceReservationValidateRecurrenceTimeConflict = {
    data: ResourceReservationValidateRecurrenceTimeConflictMutationResponse;
    error: ResourceReservationValidateRecurrenceTimeConflict401;
    request: ResourceReservationValidateRecurrenceTimeConflictMutationRequest;
    pathParams: never;
    queryParams: never;
    headerParams: never;
    response: ResourceReservationValidateRecurrenceTimeConflictMutationResponse;
    client: {
        parameters: Partial<Parameters<ResourceReservationValidateRecurrenceTimeConflictClient>[0]>;
        return: Awaited<ReturnType<ResourceReservationValidateRecurrenceTimeConflictClient>>;
    };
};
/**
 * @summary 验证周期性规则时间冲突
 * @link /api/v5/resource-reservations/validate-recurrence-time-conflict
 */
export function useResourceReservationValidateRecurrenceTimeConflict(options: {
    invalidationOnSuccess?: boolean;
    mutation?: UseMutationOptions<ResourceReservationValidateRecurrenceTimeConflict["response"], ResourceReservationValidateRecurrenceTimeConflict["error"], {
        data?: ResourceReservationValidateRecurrenceTimeConflict["request"];
    }>;
    client?: ResourceReservationValidateRecurrenceTimeConflict["client"]["parameters"];
} = {}) {
    const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};
    const queryClient = useQueryClient();
    let invalidationOnSuccessOption = options?.invalidationOnSuccess ?? true;
    return useMutation({
        mutationFn: async ({ data }) => {
            const res = await client<ResourceReservationValidateRecurrenceTimeConflict["data"], ResourceReservationValidateRecurrenceTimeConflict["error"], ResourceReservationValidateRecurrenceTimeConflict["request"]>({
                method: "post",
                url: `/api/v5/resource-reservations/validate-recurrence-time-conflict`,
                data,
                ...clientOptions
            });
            return res.data;
        },
        ...mutationOptions,
        onSuccess: (...args) => {
            if (invalidationOnSuccessOption) {
                queryClient.invalidateQueries({
                    queryKey: ["api", "v5", "resource-reservations"]
                });
            }
            if (mutationOptions?.onSuccess)
                mutationOptions.onSuccess(...args);
        },
    });
}